import { useContext } from 'react';
import { Icon } from '@zillow/constellation-10';
import { IconArchiveOutline, IconSpamFolderOutline } from '@zillow/constellation-icons';
import { LeadManagementContext } from '../../../../contexts/LeadManagementContextProvider';

export default function FolderStatusIcon() {
  const { isArchivedFolder, isReportedFolder } = useContext(LeadManagementContext);

  if (!isArchivedFolder && !isReportedFolder) {
    return null;
  }

  return (
    <>
      {isReportedFolder && (
        <Icon size="sm" css={{ color: 'border.action.neutral.default', marginLeft: 'tighter' }}>
          <IconSpamFolderOutline />
        </Icon>
      )}
      {isArchivedFolder && (
        <Icon size="sm" css={{ color: 'border.action.neutral.default', marginLeft: 'tighter' }}>
          <IconArchiveOutline />
        </Icon>
      )}
    </>
  );
}
